import Vue from 'vue'

Vue.prototype.$successMsg = function (message = '') {
    this.$message({
        message,
        type: 'success',
        duration: 5000
    })
}
Vue.prototype.$errorMsg = function (message = '') {
    this.$message({
        message,
        type: 'error',
        duration: 5000
    })
}
Vue.prototype.$warnMsg = function (message = '') {
    this.$message({
        message,
        type: 'warning',
        duration: 5000
    })
}
/**
 * 下载 Blob 文件函数
 * @param {Blob} blobData - Blob 数据
 * @param {Object} headers - 响应头（用于提取文件名）
 * @param {string} defaultFilename - 默认文件名
 */
export function downloadBlobFile(blobData, headers, defaultFilename = '导出文件.xlsx') {
    const contentDisposition = headers["content-disposition"];
    let filename = defaultFilename; // 默认文件名
    if (contentDisposition) {
        const utf8FilenameRegex = /filename\*=UTF-8''([\w%\-\.]+)/i;
        const asciiFilenameRegex = /filename="?([^"]+)"?/i;
        const utf8Matches = contentDisposition.match(utf8FilenameRegex);
        if (utf8Matches && utf8Matches[1]) {
            filename = decodeURIComponent(utf8Matches[1]);
        } else {
            const asciiMatches = contentDisposition.match(asciiFilenameRegex);
            if (asciiMatches && asciiMatches[1]) {
                filename = asciiMatches[1];
            }
        }
    }
    // const blob = new Blob([blobData], {
    //     type: "application/vnd.ms-excel",
    // });
    const blob = blobData; // 直接使用，不重新包装
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.style.display = "none";
    a.href = url;
    a.download = filename; // 下载文件名
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a); // 下载完成移除元素
    window.URL.revokeObjectURL(url); // 释放掉blob对象
}




/**
 * 密码强度校验函数
 * 要求：
 * - 8~20 位
 * - 至少一个字母
 * - 至少一个数字
 * - 至少一个特殊字符（常见符号）
 */
export function validatePasswordStrength(rule, value, callback) {
    // if (!value) {
    //     return callback(); // 非空校验由 required 处理
    // }
    const errors = [];
    if (value.length < 8) {
        errors.push(new Error('密码长度不能少于8个字符'));
    }
    if (value.length > 20) {
        errors.push(new Error('密码长度不能超过20个字符'));
    }
    if (!/[a-zA-Z]/.test(value)) {
        errors.push(new Error('密码必须包含至少一个字母'));
    }
    if (!/\d/.test(value)) {
        errors.push(new Error('密码必须包含至少一个数字'));
    }
    if (!/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(value)) {
        errors.push(new Error('密码必须包含至少一个特殊字符（如 ! @ # $ % 等）'));
    }
    callback(errors.length ? errors : callback())
}